<template>
  <ModelManagerPage
          lower-app-name="systemsettings"
          lower-model-name="systemsettings"
          version="1"
          obj-label="系统配置">
  </ModelManagerPage>
</template>

<script>
import ModelManagerPage from './ModelManagerPage.vue'

export default {
  name: 'SystemSettingsManager',
  props: {
  },
  components: {
    ModelManagerPage
  },
  data: function () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// SystemSettingsManager.vue?1009c0c6